


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment-timezone'

export interface DateRange {
    fromDate: Date,
    untilDate: Date,
}

export enum InputDateRangeAlign {
    left = 'left',
    right = 'right',
}

@Component
export default class InputDateRange extends Vue {
    @Prop() readonly name!: string
    @Prop() readonly value!: DateRange
    @Prop({ default: InputDateRangeAlign.left }) readonly align!: InputDateRangeAlign
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    internalValue: DateRange = null
    internalYear: number = null
    showOptions: boolean = false

    created() {
        this.internalValue = this.value
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        this.internalYear = moment(this.internalValue.fromDate).year()
        this.$emit('input', this.internalValue)
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    get componentClass(): object {
        return {
            'input-select': true,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
            'opened': this.showOptions,
        }
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }

    get fromDate(): Date {
        return this.internalValue.fromDate
    }

    get untilDate(): Date {
        return this.internalValue.untilDate
    }

    isFull(granularity): boolean {
        const fromDate = moment(this.internalValue.fromDate)
        const untilDate = moment(this.internalValue.untilDate)

        if (!fromDate.isSame(untilDate, granularity)) {
            return false
        }

        if (!fromDate.isSame(moment(fromDate).startOf(granularity), 'day')) {
            return false
        }

        if (!untilDate.isSame(moment(untilDate).endOf(granularity), 'day')) {
            return false
        }

        return true
    }

    selectFull(date, granularity) {
        const fromDate = moment(date).startOf(granularity)
        const untilDate = moment(fromDate).endOf(granularity)

        this.select(fromDate, untilDate)
    }

    select(fromDate, untilDate) {
        this.internalValue = {
            fromDate: fromDate.toDate(),
            untilDate: untilDate.toDate(),
        }
        this.showOptions = false
    }

    formatYear(date): string {
        return moment(date).format('YYYY').toLocaleString()
    }

    formatQuarter(date): string {
        return moment(date).format('Q').toLocaleString()
    }

    formatMonth(date, short: boolean = false): string {
        if (short) {
            return moment(date).format('MMM').toLocaleString()
        } else {
            return moment(date).format('MMMM').toLocaleString()
        }
    }

    formatDate(date): string {
        return moment(date).format('ll').toLocaleString()
    }

    get availableQuarters() {
        return Array.from({ length: 4 }, (v, i) => i + 1)
    }

    get availableMonths() {
        return Array.from({ length: 12 }, (v, i) => i + 1)
    }
}
